export const profilData = [
    {
        code: 'RA',
        label: 'Responsable activités'
    },
    {
        code: 'SU',
        label: 'Super Utilisateur'
    },
    {
        code: 'SUPERADMIN',
        label: 'Super Administrateur'
    },
    {
        code: "PRMP",
        label: "PRMP"
    },
    {
        code: "COMPTABLE",
        label: "COMPTABLE"
    },
]